import { Component } from '@angular/core';

import { ColumnRendererComponentV3, IconV3Component } from '@gea/digital-ui-lib';
import { Machine } from '../machines-table/machines-table.constants';

@Component({
  templateUrl: './common-alarm-renderer.component.html',
  styleUrl: './common-alarm-renderer.component.scss',
  imports: [IconV3Component],
})
export class CommonAlarmRendererComponent implements ColumnRendererComponentV3<Partial<Machine>> {
  rowData: Partial<Machine> = {};
}
